// Create a new employeeRoll object
class EmployeeRoll {
  // Initialize object properties
  constructor() {
    this.openBtn = $('.employee .modal-trigger');
    this.currentEmployee = undefined;
  }

  // Remove the modal node
  removeModals() {
    $('.modal-wrap').remove();
  }

  // Toggles scrolling on the body
  toggleScroll() {
    $('html').toggleClass('no-scroll');
  }

  // Close all modals
  closeModal() {
    this.removeModals();
    this.toggleScroll();

    // Return focus to the triggering button
    this.currentEmployee.focus();
  }

  // Initialize modal
  initModal() {
    this.removeModals();
    this.toggleScroll();

    // Gets the video URL from the data attributes
    const videoUrl = this.currentEmployee.closest('.employee').dataset.video;

    // Builds the video embed and modal HTML
    const video = '<video tabindex="0" width="650" height="365" controls><source src="' + videoUrl + '"></video>';
    const close = '<a href="#" class="close" tabindex="0">✖</a>';

    const html = '<div class="modal-wrap"><div class="modal-window">' + video + close + '</div></div>';

    // Appends the modal to the root level inside the body
    $('body').append(html);

    // Set the click & keyup event binds to the close button
    $('.modal-window .close').on('click', function(event) {
      event.preventDefault();
      this.closeModal();
    }.bind(this));

    // Allows closing modal via Escape key
    $(document).keyup(function(event) {
      if (event.key === 'Escape') {
        this.closeModal();
     }
    }.bind(this));

    // Set focus to newly-built modal
    $('.modal-window video').focus();
  }
}

// Export class as default
export default EmployeeRoll;



// WEBPACK FOOTER //
// ./scripts/components/employee-roll.js